import { httpClient } from './httpClient';

const base = '/api/pagos';

export const crearPago = (payload) => httpClient.post(base, payload);
export const listarPagos = (params = {}) => {
  const entries = Object.entries(params).filter(([, v]) => v !== null && v !== undefined && v !== '' && v !== 'all');
  const qs = new URLSearchParams(entries.map(([k, v]) => [k, String(v)])).toString();
  return httpClient.get(`${base}${qs ? `?${qs}` : ''}`);
};
export const resumenPagos = () => httpClient.get(`${base}/resumen`);
export const obtenerPago = (id) => httpClient.get(`${base}/${id}`);
export const obtenerComprobantePago = (id) => httpClient.get(`${base}/${id}/comprobante`);
export const anularPago = (id) => httpClient.del(`${base}/${id}`);

export const reporteCaja = ({ fecha_desde, fecha_hasta, cajero_id } = {}) => {
  const p = new URLSearchParams();
  if (fecha_desde) p.append('fecha_desde', fecha_desde);
  if (fecha_hasta) p.append('fecha_hasta', fecha_hasta);
  if (cajero_id)   p.append('cajero_id', cajero_id);
  const qs = p.toString();
  return httpClient.get(`${base}/reporte-caja${qs ? `?${qs}` : ''}`);
};

export const reporteCajaCajeros = () => httpClient.get(`${base}/reporte-caja/cajeros`);

export const abrirReporteCajaPdf = async ({ fecha_desde, fecha_hasta, cajero_id } = {}) => {
  const token = localStorage.getItem('token');
  const p = new URLSearchParams();
  if (fecha_desde) p.append('fecha_desde', fecha_desde);
  if (fecha_hasta) p.append('fecha_hasta', fecha_hasta);
  if (cajero_id)   p.append('cajero_id', cajero_id);
  const url = `${httpClient.baseUrl}/api/pagos/reporte-caja/pdf?${p.toString()}`;
  const res = await fetch(url, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!res.ok) throw new Error('Error al generar el PDF');
  const blob = await res.blob();
  const downloadUrl = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = downloadUrl;
  link.download = `reporte-caja-${fecha_desde || 'hoy'}.pdf`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => URL.revokeObjectURL(downloadUrl), 10000);
};

export const descargarComprobanteEscp = async (id) => {
  const token = localStorage.getItem('token');
  const url = `${httpClient.baseUrl}/api/pagos/${id}/comprobante-escp`;
  const res = await fetch(url, {
    method: 'GET',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!res.ok) {
    const msg = await res.text().catch(() => res.statusText);
    throw new Error(msg || 'Error al obtener comprobante ESC/P');
  }
  return res.arrayBuffer();
};

const pagosService = {
  crear: crearPago,
  listar: listarPagos,
  resumen: resumenPagos,
  obtener: obtenerPago,
  obtenerComprobante: obtenerComprobantePago,
  descargarComprobanteEscp,
};

export default pagosService;
